import { SettingsWebPortal } from '../Models/Settings/SettingsWebportal';
import { SoundData } from '../Models/Settings/SoundData';
import { HttpHelper } from './HttpHelper';

export abstract class SettingsWebportalHelper {
  private static baseUrl =
    HttpHelper.GetUrlBaseApi() + 'api/' + 'SettingsWebportal';

  public static GetUploadUrl() {
    return this.baseUrl + '/UploadSound';
  }

  public static async GetSetting() {
    var urlForRequest = this.baseUrl;
    return await HttpHelper.GetRequestForApi<SettingsWebPortal>(urlForRequest);
  }

  public static async UpdateSetting(setting: SettingsWebPortal, token: string) {
    var urlForRequest = this.baseUrl + '/' + setting.id;
    return await HttpHelper.UpdateRequestForApi<SettingsWebPortal>(
      urlForRequest,
      setting,
      token,
    );
  }

  public static async RemoveSound(setting: SoundData, token: string) {
    var urlForRequest = this.baseUrl + '/RemoveSound/' + setting.id;
    return await HttpHelper.DeleteRequestForApi<SoundData>(
      urlForRequest,
      setting,
      token,
    );
  }

  public static async ExportSetting(items: SettingsWebPortal, token: string) {
    var urlForRequest = this.baseUrl + '/ExportToJSON';
    await HttpHelper.PostRequestForApiForFile(urlForRequest, items, token);
  }

  public static ImportSettingWebportal() {
    return (this.baseUrl + '/UploadSettingWebPortal');
  }
}
